import { render, staticRenderFns } from "./listOfServices.vue?vue&type=template&id=4455a249&"
import script from "./listOfServices.vue?vue&type=script&lang=js&"
export * from "./listOfServices.vue?vue&type=script&lang=js&"
import style0 from "./listOfServices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports